import { useEffect } from 'react';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { resolvePath, useQuery } from '../../routes';
import { sso } from '../../layout/routes';
import { fromAccounts, fromOrganizations, useAppDispatch } from '../../store';

const useStyles = makeStyles(({
  container: {
    borderRadius: 'border-radius/border-radius-xs',
    borderWidth: 2,
    paddingTop: 16,
    paddingRight: 40,
    paddingBottom: 16,
    paddingLeft: 40,
  },
}));

const ButtonToLicenseManagement = (
  { title, width, height, fontWeight, marginRight }: {
    title?: string,
    width?: number,
    height?: number,
    fontWeight?: number,
    marginRight?: number,
  },
) => {
  const classes = useStyles();
  const intl = useIntl();
  const dispatch = useAppDispatch();

  const accountId = useQuery().get('accountId');
  const selectedAccount = useSelector(fromAccounts.selectSelectedAccount);
  const orgId = useSelector(fromOrganizations.selectFirstOrganization(Number(accountId)))?.id;

  const account = useSelector(fromAccounts.selectAccountById(Number(accountId)));

  useEffect(() => {
    if (accountId) {
      dispatch(fromOrganizations.doFetchOrganizationByAccountId({ accountId: Number(accountId) }));
    }
  }, [accountId]);

  const resolveLicenseManagementPath = () => {
    if (!selectedAccount) return '';

    if (account?.g3) {
      let finalDomain = account.domain;
      if (!finalDomain) {
        finalDomain = `ac-${accountId}`;
      }
      return `https://${finalDomain}.${process.env.REACT_APP_CUSTOM_DOMAIN_POSTFIX}/admin/account/license-management`;
    }

    return resolvePath(sso, undefined, {
      redirect_uri: `${process.env.REACT_APP_ADMIN_URL}/organization/${orgId}/admin/license_keys/kse`,
    });
  };

  return (
    <Button
      id="goto-licence-management-page"
      variant="outlined"
      size="large"
      className={classes.container}
      component={RouterLink}
      to={resolveLicenseManagementPath()}
      target="_blank"
      sx={{
        borderRadius: 2,
        width: width ?? 322,
        height: height ?? 56,
        fontWeight: fontWeight ?? 400,
        color: '#ffffff',
        ml: 1,
        mr: marginRight ?? 0,
        backgroundColor: '#5959EB',
        '&:hover': {
          backgroundColor: '#43509B',
        },
      }}
    >
      {intl.formatMessage({ id: title ?? 'payment_status.button.back_license_management' })}
    </Button>
  );
};

export default ButtonToLicenseManagement;
